<form #form="ngForm">
    <mat-card class="example-card">
        <mat-card-header class="titreFrm">
            <mat-card-title>&Eacute;QUIPEMENT</mat-card-title>
        </mat-card-header>
        <mat-card-content class="border">
            <div *ngIf="exist;else attente"></div>
            <ng-template #attente>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </ng-template>
            <mat-card class="example-card carClass">
                <mat-card-content>
                    <app-recherche [api]="generalService.api" [numColonneToShow]="1"(ChampEnter)="blurChamp($event)" #modelDir="ngModel"
                        recherche="Machineft" [param]="'1'" [param2]="'2'"  name="newMachine2" placeholder="Code équipement" [(ngModel)]="Machine" [required]="true">
                    </app-recherche>
                </mat-card-content>
            </mat-card>
        </mat-card-content>
        <mat-card-actions>
            <div style="display: flex;justify-content: space-between;">
                <button (click)="ajouter(form)" [disabled]="disableBtnAjouter" mat-raised-button
                    class="colorGreen"><mat-icon>add</mat-icon>
                    Ajouter
                </button>
                <button (click)="close()" mat-raised-button class="colorRed">
                    <mat-icon>close</mat-icon>
                    Fermer
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</form>
